// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2a62e436] .item-list__entry{position:relative}.empty-content[data-v-2a62e436]{text-align:center;margin-top:5vh}.empty-content.half-screen[data-v-2a62e436]{margin-top:0;margin-bottom:2vh}\n", ""]);
// Exports
module.exports = exports;
